import {
  DialChart,
  DialChartProps,
} from '../../components/charts/DialChart/DialChart'
import { createWidget } from '../widget-utils'

export const DialWidget = ({ value, ...props }: DialChartProps) => {
  return <DialChart value={value} {...props} />
}

export const DialWidgetDefinition = createWidget(DialWidget, {
  type: 'Dial',
})
